import React from "react";
import { useVideoStore } from "./store/use-videos-store";
import { Grid, Paper } from "@mui/material";
import imageBg from "../../../../images/bg-equipments.jpg";
import { COLOR_PRIMARY, NAVBAR_HEIGHT_SUM } from "../../../../libs/constants";
import {
  Alert,
  Button,
  Input,
  message,
  Popconfirm,
  Segmented,
  Typography,
} from "antd";
import {
  ClearOutlined,
  PlaySquareOutlined,
  SaveOutlined,
  VideoCameraAddOutlined,
} from "@ant-design/icons";
import { VideoPlayerModal, VideoRecorderNative } from "../../../../libs/shared";
import { workflowContainerVideosPost } from "../../../../libs/apis";
import Swal from "sweetalert2";
import { useOpen } from "../../../../libs/hooks";
import { removeImageBlob, getImageBlob } from "../../../../libs/helpers";
import SweetAlert from "sweetalert2";
import VideoVacio from "./video-vacio";

const { Text } = Typography;

const VideoPageComponent = () => {
  return (
    <Grid
      container
      spacing={1}
      justifyContent="center"
      sx={{
        mt: 0,
        maxHeight: `calc(100vh - ${NAVBAR_HEIGHT_SUM})`,
        minHeight: `calc(100vh - ${NAVBAR_HEIGHT_SUM})`,
        height: `calc(100vh - ${NAVBAR_HEIGHT_SUM})`,
        overflowY: "hidden",
        overflowX: "hidden",
        backgroundImage: `url(${imageBg})`,
      }}
    >
      <Grid item xs={12} sm={6} md={5}>
        <Paper elevation={2} sx={{ m: 0.5, position: "relative" }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Component />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

const Component = () => {
  const container = useVideoStore((state) => state.container);
  const [value, setValue] = React.useState<string | number>("Seleccionar");

  const handleChangeValue = (elValue: any) => {
    SweetAlert.fire({
      title: `Si cambia de opción, se borrará el video ${
        value === "Grabar" ? "grabado" : "seleccionado"
      }`,
      // text: elValue,
      icon: "warning",
      confirmButtonColor: COLOR_PRIMARY,
      confirmButtonText: `${
        value === "Seleccionar" ? "Ir a Grabar" : "Ir a Seleccionar"
      }`,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        setValue(elValue);
      }
    });
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={1}
      sx={{
        minHeight: "350px",
        marginTop: "0px",
        overflowY: "auto",
        maxHeight: "calc(100vh - 120px)",
      }}
    >
      <Container />
      {(!container || container.length < 3) && (
        <Grid item xs={12} sx={{ margin: "0px 20px 30px 20px" }}>
          <Alert
            type="error"
            message="Número de Contenedor Requerido"
            showIcon
            closable={false}
            style={{ width: "100%" }}
          />
        </Grid>
      )}
      <Grid item xs={12} sx={{ margin: "0px 20px 5px 20px" }}>
        <Segmented
          options={["Seleccionar", "Grabar"]}
          value={value}
          onChange={handleChangeValue}
          block
          size="large"
        />
      </Grid>

      {value === "Seleccionar" ? (
        <Grid
          item
          xs={12}
          sm={10}
          md={8}
          lg={6}
          xl={4}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "5px",
            // margin: "0px 20px",
          }}
        >
          <VideoVacio />{" "}
        </Grid>
      ) : (
        <VideoVacioRecorder />
      )}
      <Grid item xs={12} sx={{ margin: "20px 20px" }}>
        <Alert
          type="error"
          message={`Si sale del Módulo de Videos, o si cambia a ${
            value === "Grabar" ? "Seleccionar" : "Grabar"
          }, se borrará ${
            value === "Grabar" ? "lo grabado" : "lo seleccionado"
          }`}
          showIcon
          closable={false}
          style={{ width: "100%", fontWeight: "bold" }}
        />
      </Grid>
    </Grid>
  );
};

const Container = () => {
  const container = useVideoStore((state) => state.container);
  const setContainer = useVideoStore((state) => state.setContainer);

  const renderContenedorInput = React.useMemo(() => {
    return (
      <Input
        value={container || ""}
        onChange={(e) => setContainer(e.target.value.toUpperCase())}
        addonBefore="CONTENEDOR"
        size="large"
        style={{ width: "100%" }}
        allowClear
      />
    );
  }, [container]);

  return (
    <Grid item xs={12} sx={{ margin: "0px 20px 5px 20px" }}>
      {renderContenedorInput}
    </Grid>
  );
};

const VideoVacioRecorder = () => {
  const container = useVideoStore((state) => state.container);
  const [loading, setLoading] = React.useState(false); // Maneja el estado de carga
  const [emptyInternalVideo, setEmptyInternalVideo] = React.useState("");
  const [showModal, setShowModal] = React.useState(false);
  const [continuoModal, setContinuoModal] = React.useState(false);
  const [playerOpen, setPlayerOpen] = React.useState(false);
  const {
    open: openViConVa,
    handleClose: handleCloseViConVa,
    handleOpen: handleOpenViConVa,
  } = useOpen();

  React.useEffect(() => {
    if (!continuoModal) {
      setContinuoModal(false);
      handleOpenViConVa();
    }
  }, [continuoModal]);

  const handleShowModal = () => {
    setShowModal(true);
    setContinuoModal(true);
  };

  const handleCloseModal = () => {
    handleCloseViConVa();
    setShowModal(false);
    setContinuoModal(false);
  };

  const handleVideoSaved = (key: string) => {
    setEmptyInternalVideo(key);
  };

  const clearVideo = async () => {
    await removeImageBlob(emptyInternalVideo);
    setEmptyInternalVideo("");
    setPlayerOpen(false);
  };

  const openPlayer = () => {
    setPlayerOpen(true);
  };

  const closePlayer = () => {
    setPlayerOpen(false);
  };

  const handleUpload = async () => {
    if (!emptyInternalVideo) {
      message.error("No se ha seleccionado ningún video.");
      return;
    }

    const getVideo = await getImageBlob(emptyInternalVideo);
    // const videoBlob = base64ToBlob(recordedVideoBase64);

    const formData = new FormData();
    formData.append("video", getVideo!, "video.mp4");
    formData.append("type", "videoContenedorVacio");
    formData.append("containerType", "empty");
    formData.append("container", container);

    try {
      setLoading(true);
      const { data: dataPost } = await workflowContainerVideosPost(formData);
      // message.success("Video subido exitosamente.", 5);
      Swal.fire({
        title: "Video Vacío subido exitosamente",
        icon: "success",
        confirmButtonColor: "#1677ff",
        // imageUrl: result.value.avatar_url
      });
      clearVideo();
    } catch (error: any) {
      message.error(error.toString(), 5);
    } finally {
      setLoading(false);
      // setSelectedVideo(null);
      // setPreviewUrl(null);
    }
  };

  return (
    <Grid
      item
      xs={12}
      sm={10}
      md={8}
      lg={6}
      xl={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "5px",
        // margin: "0px 20px",
      }}
    >
      {emptyInternalVideo ? (
        <Button
          color="green"
          variant="solid"
          onClick={openPlayer}
          size="large"
          style={{
            width: "100%",
            minWidth: "320px",
            maxWidth: "320px",
            fontSize: "1em",
            fontWeight: "bold",
            marginTop: "10px",
          }}
          icon={<PlaySquareOutlined />}
        >
          REPRODUCIR VIDEO
        </Button>
      ) : (
        <Button
          type={!emptyInternalVideo ? "dashed" : "primary"}
          size="large"
          danger={!emptyInternalVideo ? true : false}
          style={{
            width: "100%",
            minWidth: "320px",
            maxWidth: "320px",
            fontSize: "1.1em",
            fontWeight: "bold",
            marginTop: "10px",
          }}
          icon={<VideoCameraAddOutlined />}
          onClick={handleShowModal}
        >
          GRABAR CONTENEDOR VACIO
        </Button>
      )}
      {showModal ? (
        <VideoRecorderNative
          open={openViConVa}
          handleClose={handleCloseModal}
          onVideoSaved={handleVideoSaved}
        />
      ) : null}

      <VideoPlayerModal
        videoKey={emptyInternalVideo}
        open={playerOpen}
        onClose={closePlayer}
        onClear={clearVideo}
      />
      {emptyInternalVideo && (
        <div
          style={{
            marginTop: "10px",
            minWidth: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Popconfirm
            title="Si lo guarda no podrá editar el video"
            description="Desea Continuar?"
            onConfirm={handleUpload}
            zIndex={1601}
            okText="Si"
            cancelText="No"
          >
            <Button
              type="primary"
              size="large"
              icon={<SaveOutlined />}
              loading={loading}
              style={{ marginRight: "10px", fontSize: "1.1em" }}
              disabled={!container}
            >
              GUARDAR
            </Button>
          </Popconfirm>
          <Button
            type="dashed"
            size="large"
            icon={<ClearOutlined />}
            onClick={clearVideo}
            style={{ fontSize: "1.1em" }}
          >
            LIMPIAR
          </Button>
        </div>
      )}
    </Grid>
  );
};

export default VideoPageComponent;
